import { render, staticRenderFns } from "./addFatherDict.vue?vue&type=template&id=646b1850"
import script from "./addFatherDict.vue?vue&type=script&lang=js"
export * from "./addFatherDict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports